import React, { useEffect, useState } from 'react';
import BASE_URL from '../utils/api';

// Miniatura da foto do produto no card. A imagem vem do servidor com o login (o banco é o da empresa
// logada), por isso é buscada com fetch e mostrada como blob. Sem foto: um ícone no lugar.
export default function FotoProdutoThumb({ produtoId, temFoto, versao, tamanho = 110 }) {
  const [url, setUrl] = useState(null);

  useEffect(() => {
    if (!produtoId || !temFoto) { setUrl(null); return undefined; }
    let ativo = true;
    let objectUrl = null;
    fetch(`${BASE_URL}/Produto/${produtoId}/foto`)
      .then(r => (r.ok ? r.blob() : null))
      .then(blob => {
        if (!ativo || !blob) return;
        objectUrl = URL.createObjectURL(blob);
        setUrl(objectUrl);
      })
      .catch(() => { if (ativo) setUrl(null); });
    return () => {
      ativo = false;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [produtoId, temFoto, versao]);

  return (
    <div className="produto-foto-thumb" style={{ width: tamanho, height: tamanho }}>
      {url
        ? <img src={url} alt="Foto do produto" />
        : <span className="produto-foto-vazia" title={temFoto ? 'Carregando foto...' : 'Produto sem foto'}>📦</span>}
    </div>
  );
}
